import { render, staticRenderFns } from "./opportunity-create.vue?vue&type=template&id=63052372&"
import script from "./opportunity-create.vue?vue&type=script&lang=js&"
export * from "./opportunity-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports